import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { TimerComponent } from 'src/app/ui-design-library/timer/timer.component';

@Component({
  selector: 'fnsr-header',
  standalone: true,
  imports: [RouterModule, IconComponent, TimerComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  showBurgerMenu: boolean = false;

  closeBurgerMenu() {
    this.showBurgerMenu = false; 
  }

  public isEnvelopeAnimated = false;

  constructor(
    public authService: AuthService,
    public router: Router) {}

  public logout(): void {
    this.authService.logout();
  }
}
